import { initialBreakdownState as agentMovementInitialBreakdownState } from '../../agent-production/constants/breakdowns';
import { modules } from '../../constants';
import { initialBreakdownsState as marketDynamicInitialBreakdownState } from '../marketDynamics';

export const breakdownModules = {
    [modules.marketDynamics.marketDynamics]: {
        initialState: marketDynamicInitialBreakdownState
    },
    [modules.proficiencyMetrics.agentMovement]: {
        initialState: agentMovementInitialBreakdownState
    }
};
